import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { AppService } from './shared/app.service';
import { MenuService, IIconMenuItem } from './shared/menu.service';
import { FlyoutService, IFlyout } from './shared/flyout.service';
import { GlobalDataService } from './shared/global-data.service';
import { getDefaultSearchArgs, ICommonSearchArgs } from 'src/app/shared/common-search-args';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoginNavService } from 'src/app/shared/login.nav-service';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { RecenteBladwijzersComponent } from './bladwijzers/recente-bladwijzers/recente-bladwijzers.component';
import { RecenteNotitiesComponent } from './shared/notities/recente-notities/recente-notities.component';
import { FormsModule } from '@angular/forms';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { ErrorDialogComponent } from './cevi-shared/error-dialog/error-dialog.component';
import { LoadingComponent } from './cevi-shared/loading/loading.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [LoadingComponent, ErrorDialogComponent, NgFor, FormsModule, NgClass, RouterOutlet, NgIf, RecenteNotitiesComponent, RecenteBladwijzersComponent, DocumentViewerComponent]
})
export class AppComponent implements OnInit {

  ngOnInit(): void {
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loginNavService.setReturnUrl(event.url);
        if (!!event.url && event.url.match(/^\/#/)) {
          this.router.navigate([event.url.replace('/#', '')]);
        }
      }
    });
    this.menuService.retrieveBadges();
    this.appDataService.getAppGlobalData().subscribe(result => {
      this.menuService.setAppGlobalData(result);
    });
  }
  title = 'app';
  public recenteNotitiesFlyout: IFlyout;
  public recenteBladwijzersFlyout: IFlyout;

  private lastTime = 0;
  // testcode public list = Array.from(new Array(50), (v, i) => i);
  constructor(public appService: AppService, public menuService: MenuService,
    private loginNavService:LoginNavService,
    private appDataService: GlobalDataService,
    private router: Router,
    flyoutService: FlyoutService    
  ) {
    this.zoekArg = getDefaultSearchArgs();
    this.recenteNotitiesFlyout = flyoutService.create();
    this.recenteBladwijzersFlyout = flyoutService.create();
    this.menuService.addNotitieFlyout(this.recenteNotitiesFlyout);
    this.menuService.addRecenteBladwijzersFlyout(this.recenteBladwijzersFlyout);
  }
  zoekArg: ICommonSearchArgs;
  zoek() {
    this.menuService.globalSearchNew(this.zoekArg);
  }
  
  navigateToIconMenuItem(item: IIconMenuItem) {
    // test error popup
    // private errorDialogService: ErrordialogService
    // const errors = Array.from(Array(50).keys()).map(n => (
    //   { ErrorId:'1', FriendlyMessage:'Er is een fout opgetreden',Message:'none'}
    // ));
    // this.errorDialogService.setErrorData({
    //   Errors:errors,
    //   ExceptionType:'Waarschuwing'
    // }); return false;
    this.menuService.navigateToIconMenuItem(item);
    return false;
  }
  onRefresh() {
    this.appService.refreshActiveComponents();
    return false;
  }

  @ViewChild('recenteNotities')
  set recenteNotities(value: ElementRef) {
    this.recenteNotitiesFlyout.animationElement = value;
  }

  @ViewChild('recenteBladwijzers')
  set recenteBladwijzers(value: ElementRef) {
    this.recenteBladwijzersFlyout.animationElement = value;
  }

}
